export const FILE_MAXIMUM_SIZE = 83886080;
